import { render, staticRenderFns } from "./Extrato.html?vue&type=template&id=dcec2fde&external"
import script from "./Extrato.vue?vue&type=script&lang=js"
export * from "./Extrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports